import styled from 'styled-components';
import { StyledWrapper } from '../styled';

export const StyledContainer = styled(StyledWrapper)`
  position: initial;
  ${({$strategy})=>$strategy && `
    @media(min-width:1200px) {min-height:0;max-width:none;box-sizing:border-box;align-content:flex-start;}
  `}
`;
